<template>
  <v-app app>
    <template>
      <vue-snotify></vue-snotify>
      <v-app-bar absolute app color="white" elevation="6">
        <div :class="logoClass"></div>
      </v-app-bar>
      <div class="content-wrapper">
        <v-container fluid fill-height>
          <v-row align="center" justify="center">
            <v-col lg="6" xl="4" md="6" sm="12" cols="12">
              <router-view></router-view>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-footer padless>
        <v-col cols="6">
          <div class="text-body-14-nk" style="margin-bottom: 0 !important;">
            {{ $t(buildLocalizationKey('components.footer.contactEmailDescription')) }} <a :href="`mailto:${$t(buildLocalizationKey('components.footer.contactEmail'))}`">{{ $t(buildLocalizationKey('components.footer.contactEmail')) }}</a>
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right" cols="6">
          <div class="text-body-14-nk" style="margin-bottom: 0 !important;">{{ $t(buildLocalizationKey('components.footer.yearSince')) }} &mdash; {{ $t(buildLocalizationKey('components.footer.company')) }}</div>
        </v-col>
      </v-footer>
    </template>
  </v-app>
</template>

<script>
import {getCompanyContext} from "@/helpers/context";

export default {
  name: 'App',
  data() {
    const companyContext = getCompanyContext()
    return {
      logoClass: `${companyContext}-logo`,
    }
  },
  methods: {
    buildLocalizationKey(key) {
      const companyContext = getCompanyContext()
      return `${companyContext}.${key}`
    }
  }
}
</script>

<style>
.content-wrapper {
  height: 100%;
}

.error-message {
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
  line-height: 12px;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

.fg-logo {
  display: block;
  text-indent: -9999px;
  width: 160px;
  height: 64px;
  background: url(/img/fg-logo.svg);
  background-size: 160px 64px;
  cursor: pointer;
}

.kromos-logo {
  display: block;
  text-indent: -9999px;
  width: 173px;
  height: 50px;
  background: url(/img/kromos-logo.png);
  background-size: 173px 50px;
  cursor: pointer;
}
</style>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.text-button-nk {
  color: map-get(map-get($colors, 'light-blue-nk'), 'n700');
  cursor: pointer;
}

.auth-content {
  margin: 0 auto;
}

.info-text {
  color: map-get(map-get($colors, 'blue-grey-nk'), 'n900');
}
</style>